const FAQ_QUESTION_KEY_PATTERN = /^faq\.(\d+)\.q$/;

export type SupportFaqItem = {
  id: string;
  questionId: string;
  answerId: string;
};

export const getFaqItemsFromMessages = (
  messages: Record<string, unknown>
): SupportFaqItem[] =>
  Object.keys(messages)
    .reduce<SupportFaqItem[]>((items, key) => {
      const match = key.match(FAQ_QUESTION_KEY_PATTERN);

      if (!match) {
        return items;
      }

      const index = match[1];
      const answerId = `faq.${index}.a`;

      if (typeof messages[answerId] !== 'string') {
        return items;
      }

      items.push({
        id: `faq-${index}`,
        questionId: key,
        answerId,
      });

      return items;
    }, [])
    .sort(
      (a, b) =>
        Number(a.questionId.match(FAQ_QUESTION_KEY_PATTERN)?.[1]) -
        Number(b.questionId.match(FAQ_QUESTION_KEY_PATTERN)?.[1])
    );
